export default __webpack_public_path__ + "static/media/Puneet.f76146bf.jpg";